import { SearchOutlined } from "@ant-design/icons";
import { Drawer,  } from "antd";
import { useState } from "react";
import Search from "./Search";

const MobileSearch = () => {
    const [isShowSearchDrawer,setIsShowSearchDrawer] = useState(false)
    return ( <>
         <SearchOutlined onClick={()=>{
            setIsShowSearchDrawer(true)
         }}  className="hover:cursor-pointer !text-black !text-lg"/>

         <Drawer
         footer={false}
         open={isShowSearchDrawer}
         onClose={()=>{
            setIsShowSearchDrawer(false)
         }}
         >
            <Search/>
         </Drawer>
    </>
    
);
}
 
export default MobileSearch;